import { render, staticRenderFns } from "./header2.vue?vue&type=template&id=0b71bb6d&scoped=true&"
import script from "./header2.vue?vue&type=script&lang=js&"
export * from "./header2.vue?vue&type=script&lang=js&"
import style0 from "./header2.vue?vue&type=style&index=0&id=0b71bb6d&lang=scss&scoped=true&"
import style1 from "./header2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71bb6d",
  null
  
)

export default component.exports